import * as Klaro from 'klaro/dist/klaro-no-css';

const config = {
    version: 1,
    elementID: 'klaro',
    styling: {
        theme: [
            'light',
            // 'top',
            // 'wide'
        ],
    },
    htmlTexts: true,
    embedded: false,
    groupByPurpose: false,
    storageMethod: 'cookie',
    cookieName: 'klaro',
    cookieExpiresAfterDays: 365,
    //cookieDomain: '.github.com',
    //cookiePath: '/',
    default: false,
    mustConsent: false,
    acceptAll: true,
    hideDeclineAll: false,
    hideLearnMore: false,
    noticeAsModal: false,
    //disablePoweredBy: true,
    //additionalClass: 'my-klaro',
    //lang: 'de',
    translations: {
        // zz = default translations.
        zz: {},
        de: {
            privacyPolicyUrl: '/datenschutz',
            consentNotice: {
                changeDescription: 'Es gab Änderungen seit Ihrem letzten Besuch, bitte aktualisieren Sie Ihre Auswahl.',
                description: 'Ihre Privatsphäre ist uns wichtig. Deswegen verwenden wir ohne Ihre Zustimmung keine externen Services oder erfassen persönliche Daten. Sie können dem Einsatz von externen Services für die folgenden Zwecke hier zustimmen, ihn ablehnen oder individuelle Einstellungen treffen: {purposes}',
                learnMore: 'Individuelle Einstellungen',
            },
            consentModal: {
                title: 'Ihre Privatsphäre-Einstellungen',
                description: 'Hier können Sie einsehen und anpassen, welche persönlichen Daten wir erfassen und welche externen Services wir nutzen.',
                privacyPolicy: {
                    name: 'Datenschutzerklärung',
                    text: 'Weitere Details finden Sie in unserer {privacyPolicy}.',
                }
            },
            ok: 'Zustimmen',
            save: 'Speichern',
            decline: 'Ablehnen',
            close: 'Schließen',
            acceptSelected: 'Auswahl speichern',
            acceptAll: 'Allen zustimmen',
            app: {
                disableAll: {
                    title: 'Alle Anwendungen umschalten',
                    description: 'Mit dieser Schaltfläche können Sie alle Anwendungen auf einmal aktivieren bzw. deaktivieren.',
                },
                optOut: {
                    title: '(Opt-Out)',
                    description: 'Diese Anwendung wird standardmäßig geladen (Sie können sie aber deaktivieren)',
                },
                required: {
                    title: '(immer notwendig)',
                    description: 'Diese Anwendung wird immer benötigt.',
                },
                purposes: 'Verwendungszwecke',
                purpose: 'Verwendungszweck',
            },
            poweredBy: 'Umgesetzt mit Klaro!',

            purposes: {
                general: 'Basisfunktionalität & Sicherheit',
                multimedia: 'Externe Inhalte',
                analytics: 'Statistik',
            },

            // translations for service descriptions
            klaro: {
                description: 'In dem klaro-Cookie werden Iher hier getroffenen Privatsphäre-Einstellungen gespeichert.'
            },
            csrf: {
                description: 'Verhindert gefälsche Anfragen von externen Seiten.',
            },
            YouTube: {
                description: 'Diese Option aktiviert eingebettete YouTube-Videos.',
            },
            Vimeo: {
                description: 'Diese Option aktiviert eingebettete Vimeo-Videos.'
            },
            matomo: {
                description: 'Wir verwenden die Open-Source-Software Matomo, um anonyme Besucherstatistiken zu sammeln. Hierbei werden keine privaten Daten erfasst.',
            },
        },
    },

    // This is a list of third-party services that Klaro will manage for you.
    services: [
        {
            name: 'klaro',
            default: true,
            required: true,
            title: 'Privatsphäre-Einstellungen',
            purposes: ['general'],
            cookies: ['klaro'],
        },
        {
            name: 'csrf',
            default: true,
            required: true,
            title: 'CSRF Schutz',
            purposes: ['general'],
            cookies: ['CRAFT_CSRF_TOKEN'],
        },
        {
            name: 'matomo',
            default: true,
            onlyOnce: true,
            title: 'Anonymisierte Besucherstatistiken (Matomo)',
            purposes: ['analytics'],
            cookies: [
                /^_pk_.*$/,
            ],
        },
        {
            name: 'YouTube',
            title: 'YouTube',
            purposes: ['multimedia'],
        },
        {
            name: 'Vimeo',
            title: 'Vimeo',
            purposes: ['multimedia'],
        },
    ],
};

// Initialize klaro with the given config.
Klaro.setup(config);

// Provide global access to the klaro instance and its config.
window.klaro = Klaro;
window.klaroConfig = config;

// Provide a utility class for links to open the klaro modal.
const managePrivacyPreferencesLinks = Array.from(document.querySelectorAll('.klaro-show'));
managePrivacyPreferencesLinks.forEach(link => link.addEventListener('click', e => {
    e.preventDefault();
    window.klaro.show();
}));
